import React from 'react'
import isDeepEqual from 'lodash/isMatch'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import { useQuery, useCommand } from '~/client/hooks/cqrpc'
import Link from '~/client/components/Link'
import ErrorMessage from '~/client/components/ErrorMessage'
import Timestamp from '~/client/components/Timestamp'
import Form from '~/client/components/Form'
import FormButtonRow from '~/client/components/FormButtonRow'
import JSONSchemaFormInput from '~/client/components/JSONSchemaFormInput'
import StarOutlineIcon from '@mui/icons-material/StarOutline'
import StarRateIcon from '@mui/icons-material/StarRate';

export default function ConnectionDetailsForm({
  host,
  onSuccess,
  ...props
}) {
  const query = useQuery('apps.getByHost', { host: host })
  const app = query.result

  return <Form
    {...props}
    onSubmit={() => {}}
    disabled={query.loading}
  >
    <TextField {...{
      disabled: true,
      required: false,
      fullWidth: true,
      label: 'Data Sharing Agreement',
      name: 'filename',
      sx: {mb: 2},
      value: app.agreement,
      placeholder: ''
    }}/>
    <TextField {...{
      disabled: true,
      required: false,
      fullWidth: true,
      label: 'Date of sharing agreement',
      name: 'filename',
      sx: {mb: 2},
      value: app.createdAt,
      placeholder: ''
    }}/>
    <TextField {...{
      disabled: true,
      required: false,
      fullWidth: true,
      label: 'Person responsible for data usage',
      name: 'filename',
      sx: {mb: 2},
      value: app.contactPerson,
      placeholder: ''
    }}/>
    <TextField {...{
      disabled: true,
      required: false,
      fullWidth: true,
      label: 'Position of responsible person',
      name: 'filename',
      sx: {mb: 2},
      value: app.contactPosition,
      placeholder: ''
    }}/>
    <TextField {...{
      disabled: true,
      required: false,
      fullWidth: true,
      label: 'Email address for enquiries and issues',
      name: 'filename',
      sx: {mb: 2},
      value: app.contactEmail,
      placeholder: ''
    }}/>
    <TextField {...{
      disabled: true,
      required: false,
      fullWidth: true,
      label: 'My rating of their usage of my data',
      name: 'filename',
      sx: {mb: 2},
      value: '3 stars',
      placeholder: '',
      startAdornment: (
        <InputAdornment position="start">
          <StarRateIcon fontSize="large" />
          <StarRateIcon fontSize="large" />
          <StarRateIcon fontSize="large" />
          <StarOutlineIcon fontSize="large" />
          <StarOutlineIcon fontSize="large" />
        </InputAdornment>
      )
    }}/>
  </Form>
}

